module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Currency:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.currency,
      "label": "Currency",
      "autocomplete": "",
      "solo": ""
    },
    on: {
      "input": _vm.fncCheckForex
    },
    model: {
      value: (_vm.currencyCurrency),
      callback: function($$v) {
        _vm.currencyCurrency = $$v
      },
      expression: "currencyCurrency"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Value:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Value",
      "solo": ""
    },
    model: {
      value: (_vm.currencyRate),
      callback: function($$v) {
        _vm.currencyRate = $$v
      },
      expression: "currencyRate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Tax Label")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Tax Label",
      "solo": ""
    },
    model: {
      value: (_vm.taxLabel),
      callback: function($$v) {
        _vm.taxLabel = $$v
      },
      expression: "taxLabel"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Tax Rate:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Tax Rate",
      "solo": ""
    },
    model: {
      value: (_vm.taxRate),
      callback: function($$v) {
        _vm.taxRate = $$v
      },
      expression: "taxRate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncUpdateForex()
      }
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('small', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "requiredMessage",
    attrs: {
      "lg12": ""
    }
  }, [_vm._v("\n\t\t\t\t \n\t\t\t")])], 1)], 1)
},staticRenderFns: []}